__turbopack_context__.v({
  "icon": "jmiysa_icon",
});
